import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/utils/isplainobject/isplainobject.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";

export default obj => {
	obj.each(function () {
		const actions = $(this).data("hashform") || {};
		for (const [key, value] of Object.entries(actions)) {
			const check = $("#" + key);
			check.on("change", function () {
				if (this.checked) {
					if ($.isPlainObject(value)) {
						for (const [question, target] of Object.entries(value)) {
							if ($("#" + question).prop("checked")) {
								$("#" + target).prop("checked", true).trigger("change");
								break;
							}
						}
					} else {
						$("#" + value).prop("checked", true).trigger("change");
					}
				}
			});
		}
	});
};